import React, { useRef, useState } from "react";
import { Form, Radio, Button, Card, Alert, Row, Col, Divider } from "antd";
import background from "../assets/rsms_blur.jpg";
import logo from "../assets/logo.jpeg";
import axios from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
const indikatorList = [
  { id: 1, highlight: "", rest: "Demam ≥ 7 hari dan/atau berkeringat hebat" },
  {
    id: 2,
    highlight: "",
    rest: "Nyeri kepala yang makin memberat dengan/tanpa disertai muntah hebat",
  },
  { id: 3, highlight: "", rest: "Nyeri tulang yang mengganggu aktifitas" },
  {
    id: 4,
    highlight: "",
    rest: "Gangguan pengelihatan : buram, dobel, buta mendadak",
  },
  {
    id: 5,
    highlight: "",
    rest: "Nafsu makan hilang, penurunan berat badan, dan kelelahan dalam 3 bulan terakhir",
  },
  {
    id: 6,
    highlight: "Pucat disertai tanda-tanda perdarahan: ",
    rest: " bintik-bintik merah di kulit (petekie), lebam (hematom), mimisan (epistaksis), gusi berdarah",
  },
  {
    id: 7,
    highlight: "Kelainan mata: ",
    rest: " mata kucing (lekokorea), mata juling (strabismus) tiba-tiba, tidak memiliki iris (aniridia), perbedaan warna kedua mata (heterokromia), perdarahan di mata (hifema), mata menonjol (proptosis)",
  },
  {
    id: 8,
    highlight: "Pembesaran kelenjar getah bening",
    rest: "dengan ukuran 2 – 5 cm, keras, tidak nyeri, dan berlangsung ≥ 4 minggu",
  },
  {
    id: 9,
    highlight: "Gangguan neurologi mendadak dan progresif berupa:",
    rest: " kejang tanpa demam atau tanpa penyebab yang jelas, kelemahan tubuh di satu sisi, wajah asimetris, penurunan kesadaran dan/atau perubahan status mental, hilang keseimbangan atau pincang saat berjalan, kesulitan bicara",
  },
  {
    id: 10,
    highlight: "Organomegali",
    rest: ": Pembesaran hepar (hepatomegali) dan/atau limpa (splenomegali)",
  },
  {
    id: 11,
    highlight: "Benjolan",
    rest: "yang teraba di perut atau bagian tubuh lain",
  },
];
const IndikatorKankerAnak = () => {
  const hasilRef = useRef(null);
  const [form] = Form.useForm();
  const [hasil, setHasil] = useState(null);
  // const JudulBerwarna = () => {
  //   const text = "Anamnesis - Periksa – Identifikasi – Klasifikasi";

  //   // Pecah berdasarkan spasi
  //   const words = text.split(" ");

  //   return (
  //     <div style={{ textAlign: "center", fontSize: 16, fontWeight: "bold" }}>
  //       {words.map((word, index) => (
  //         <span key={index} style={{ marginRight: 4 }}>
  //           {/* Cari huruf pertama dan sisanya */}
  //           <span style={{ color: "red" }}>{word.charAt(0)}</span>
  //           {word.slice(1)}
  //         </span>
  //       ))}
  //     </div>
  //   );
  // };
  const handleFinish = async (values) => {
    const tanggalWIB = dayjs().tz("Asia/Jakarta").format("YYYY-MM-DD HH:mm:ss");
    const jawaban = Object.values(values);
    const isAnyYa = jawaban.some((v, idx) => v === "ya" && idx !== 4); // idx 4 = indikator 5
    const isOnlyLimaYa = jawaban.every((v, idx) =>
      idx === 4 ? v === "ya" : v === "tidak"
    );
    const isAllTidak = jawaban.every((v) => v === "tidak");

    let hasilSkrining = null;

    if (isAnyYa) {
      hasilSkrining = {
        warna: "red",
        status: "MERAH : Kemungkinan terkena kanker atau penyakit berat ",
        message:
          "Stabilisasi dan rujuk segera ke RS yang memiliki pelayanan hematologi dan onkologi anak.",
      };
    } else if (isOnlyLimaYa) {
      hasilSkrining = {
        warna: "gold",
        status: "KUNING : Memiliki risiko terkena kanker ",
        message:
          "Rujuk ke dokter anak untuk menentukan diagnosis penyakit dan tatalaksana yang tepat.",
      };
    } else if (isAllTidak) {
      hasilSkrining = {
        warna: "green",
        status: "HIJAU : Tidak memiliki risiko terkena kanker",
        message:
          "Memastikan pertumbuhan dan perkembangan anak sesuai usia, imunisasi lengkap, dan lakukan edukasi untuk pencegahan kanker (lingkungan anak bebas rokok, nutrisi yang seimbang dan bergizi, serta rutin  berolahraga).",
      };
    }
    // Scroll ke hasil
    setTimeout(() => {
      if (hasilRef.current) {
        hasilRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);

    if (hasilSkrining) {
      setHasil(hasilSkrining);

      // Kirim data ke backend menggunakan axios
      try {
        await axios.post(`https://v0-api-backend.vercel.app/api/simpan-data`, {
          data: values,
          hasil: hasilSkrining.status.split(":")[0].trim(), // hasil: "MERAH", "KUNING", atau "HIJAU"
          tanggal: tanggalWIB,
          // tanggal: new Date().toISOString().slice(0, 19).replace("T", " "),
        });
      } catch (err) {
        console.error("Gagal menyimpan ke database:", err);
      }
    } else {
      setHasil(null);
    }
  };

  // Bagi dua list
  //   const half = Math.ceil(indikatorList.length / 2);
  //   const leftColumn = indikatorList.slice(0, half);
  //   const rightColumn = indikatorList.slice(half);
  const anamnesis = indikatorList.slice(0, 5);
  const identifikasi = indikatorList.slice(5);

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${background})`, // Ganti path dengan file kamu
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        padding: "16px",
        minWidth: "-webkit-fill-available",
      }}
    >
      <Card
        title={
          <>
            {/* <div
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                wordWrap: "break-word", // Agar teks terbungkus
                whiteSpace: "normal", // Memungkinkan teks untuk turun ke baris berikutnya
                textAlign: "center",
              }}
            >
              Deteksi Dini Kanker Anak
            </div>
            <div
              style={{
                fontSize: "14",
                fontWeight: "bold",
                wordWrap: "break-word", // Agar teks terbungkus
                whiteSpace: "normal", // Memungkinkan teks untuk turun ke baris berikutnya
                textAlign: "center",
              }}
            >
              <JudulBerwarna />
            </div>
            <div
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                wordWrap: "break-word", // Agar teks terbungkus
                whiteSpace: "normal", // Memungkinkan teks untuk turun ke baris berikutnya
                textAlign: "center",
              }}
            >
              (DIDIK ANAK APIK)
            </div> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
                flexWrap: "wrap",
                textAlign: "center",
              }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{
                  width: "100%",
                  maxWidth: 400, // maksimal lebar logo di layar besar
                  height: "auto", // tinggi akan mengikuti rasio gambar
                  objectFit: "contain",
                }}
              />
            </div>
          </>
        }
        style={{ maxWidth: 900, margin: "0 auto", padding: "24px" }}
        size="small"
      >
        <p>
          • Setiap kali anak mengunjungi layanan kesehatan karena sebab apapun,
          kita harus menilai kemungkinan bahwa anak tersebut berisiko terkena
          kanker <br />• Lakukan langkah-langkah deteksi dini kanker pada anak:
          Anamnesis - Periksa & Identifikasi - Klasifikasi <br />• Skrining ini
          bertujuan untuk memastikan bahwa diagnosis dan pengobatan bagi anak
          yang terkena kanker tidak tertunda
        </p>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          onFinishFailed={({ errorFields }) => {
            if (errorFields.length > 0) {
              form.scrollToField(errorFields[0].name[0], {
                behavior: "smooth",
                block: "center",
              });
            }
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Divider
                orientation="center"
                style={{ backgroundColor: "#d9f7be", margin: "0px 0 16px" }}
              >
                Anamnesis
              </Divider>
              {anamnesis.map((indikator) => (
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    padding: "12px 16px",
                    marginBottom: 16,
                    borderRadius: 8,
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <Form.Item
                    key={indikator.id}
                    name={`indikator_${indikator.id}`}
                    label={
                      <span>
                        {indikator.id}. <strong>{indikator.highlight}</strong>{" "}
                        {indikator.rest}
                      </span>
                    }
                    rules={[
                      { required: true, message: "Mohon pilih salah satu" },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <Radio.Group>
                      <Radio value="ya">Ya</Radio>
                      <Radio value="tidak">Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              ))}
            </Col>

            <Col xs={24} md={12}>
              <Divider
                orientation="center"
                style={{ backgroundColor: "#ffd591", margin: "0px 0 16px" }}
              >
                Periksa & Identifikasi
              </Divider>
              {identifikasi.map((indikator) => (
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    padding: "12px 16px",
                    marginBottom: 16,
                    borderRadius: 8,
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <Form.Item
                    key={indikator.id}
                    name={`indikator_${indikator.id}`}
                    label={
                      <span>
                        {indikator.id}. <strong>{indikator.highlight}</strong>{" "}
                        {indikator.rest}
                      </span>
                    }
                    rules={[
                      { required: true, message: "Mohon pilih salah satu" },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <Radio.Group>
                      <Radio value="ya">Ya</Radio>
                      <Radio value="tidak">Tidak</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              ))}
            </Col>
          </Row>

          <Form.Item style={{ textAlign: "right" }}>
            <Button type="primary" htmlType="submit">
              Hitung Klasifikasi
            </Button>
          </Form.Item>
        </Form>
        {hasil && (
          <div ref={hasilRef}>
            <Alert
              showIcon
              type={
                hasil.warna === "red"
                  ? "error"
                  : hasil.warna === "gold"
                    ? "warning"
                    : "success"
              }
              message={
                <span>
                  Hasil Skrining:{" "}
                  <strong style={{ color: hasil.warna }}>
                    {hasil.status.split(":")[0]}
                  </strong>
                  {":"}
                  {hasil.status.split(":")[1]}
                </span>
              }
              description={hasil.message}
              style={{ marginTop: 20 }}
            />
          </div>
        )}
        <div style={{ marginTop: 40, textAlign: "center" }}>
          <p style={{ fontSize: "12px", color: "#888" }}>
            *Pan American Health Organization, World Health Organization (2014):{" "}
            <em>Early diagnosis of childhood cancer</em>.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default IndikatorKankerAnak;
